/** Kubernetes の CPU 量 ("500m" / "2") を vCPU 数にする。解釈できなければ NaN。 */
export function parseCpu(quantity: string): number {
	return quantity.endsWith("m") ? Number(quantity.slice(0, -1)) / 1000 : Number(quantity);
}

/** Kubernetes の CPU 量 ("500m" / "2") を vCPU 数の表記に直す。 */
export function formatCpu(quantity: string): string {
	const cores = parseCpu(quantity);
	return Number.isFinite(cores) ? `${cores}` : quantity;
}

const MEMORY_UNIT_BYTES: Record<string, number> = {
	Ki: 2 ** 10,
	Mi: 2 ** 20,
	Gi: 2 ** 30,
	Ti: 2 ** 40,
};

/** Kubernetes のメモリ量 ("2Gi") をバイト数にする。解釈できなければ NaN。 */
export function parseMemoryBytes(quantity: string): number {
	const match = /^(\d+(?:\.\d+)?)(Ki|Mi|Gi|Ti)$/.exec(quantity);
	return match ? Number(match[1]) * MEMORY_UNIT_BYTES[match[2]] : NaN;
}

/** バイト数を小数 1 桁に切り捨てた GiB の数 ("15.5") にする。 */
export function formatGib(bytes: number): string {
	return `${Math.floor((bytes * 10) / 2 ** 30) / 10}`;
}

/** Kubernetes のメモリ量 ("2Gi") を表示用 ("2 GiB") に直す。 */
export function formatMemory(quantity: string): string {
	const match = /^(\d+(?:\.\d+)?)(Gi|Mi)$/.exec(quantity);
	if (!match) return quantity;
	return `${match[1]} ${match[2]}B`;
}

/** CPU の request〜limit を vCPU の範囲で表す (同じなら 1 値)。 */
export function formatCpuRange(request: string, limit: string): string {
	const from = formatCpu(request);
	const to = formatCpu(limit);
	return from === to ? `${to} vCPU` : `${from}〜${to} vCPU`;
}
